<template>
  <div>
    <view v-if="showAppList" v-loading="loading">
      <vab-query-form>
        <view class="right-panel" :span="12">
          <el-button
            icon="el-icon-plus"
            type="primary"
            @click="showAppList = false"
          >
            添加应用
          </el-button>
        </view>
      </vab-query-form>

      <el-table
        :data="appList"
        border
        stripe
        style="width: 100%"
        header-row-class-name="header-row"
      >
        <el-table-column align="center" label="序号">
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="应用名称">
        </el-table-column>
        <el-table-column prop="typename" align="center" label="领域">
        </el-table-column>
        <el-table-column prop="appSecret" align="center" label="appSecret">
        </el-table-column>

        <el-table-column prop="createTime" align="center" label="编辑发布">
          <template #default="{row}">
            <el-button
              type="text"
              @click="handleEdit(row)"
              v-if="row.auditStatusName !== '审核通过'"
            >
              编辑发布
            </el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="审核状态">
          <template #default="{row}">
            {{ row.auditStatusName }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleAppCurrentChange"
        layout="prev, pager, next"
        :current-page="appPager.curPageNumber"
        :total="appPager.total"
      >
      </el-pagination>
    </view>
    <view v-else>
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="180px"
        style="width:100%"
      >
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              <span>基础信息</span>
            </div>
          </template>
          <el-col :span="22">
            <el-form-item label="应用名称" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="标签" prop="code">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
            <el-form-item label="领域" prop="appTypeId">
              <el-checkbox-group v-model="form.appTypeId">
                <el-checkbox
                  v-for="(item, index) in appTypeList"
                  :label="item.id"
                  :key="index"
                  name="appTypeId"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="开发团队" prop="provider">
              <el-input v-model="form.provider"></el-input>
            </el-form-item>

            <el-form-item label="描述" prop="description">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.description"
              ></el-input>
            </el-form-item>

            <div class="el-card__header" style="margin-bottom:20px;">
              <span>应用信息</span>
            </div>

            <el-form-item label="应用图片" prop="logoUrl">
              <my-upload
                v-model="showLogo"
                :no-circle="true"
                :no-square="true"
                field="img"
                :width="66"
                :height="66"
                img-format="jpg, jpeg, png"
                @crop-success="cropSuccesss"
              />
              <img
                width="100"
                height="100"
                :src="form.showlogo"
                @click="toggleShowl"
              />
            </el-form-item>

            <el-form-item label="应用类型(IOS/Android)" prop="adapterSystem">
              <el-input v-model="form.adapterSystem"></el-input>
            </el-form-item>
            <el-form-item label="应用地址(Android)" prop="previewUrlTwo">
              <el-input v-model="form.previewUrlTwo"></el-input>
            </el-form-item>
            <el-form-item label="应用地址(IOS)" prop="previewUrlOne">
              <el-input v-model="form.previewUrlOne"></el-input>
            </el-form-item>
            <el-form-item label="应用地址(Win)" prop="previewUrlFour">
              <el-input v-model="form.previewUrlFour"></el-input>
            </el-form-item>
            <el-form-item label="应用地址(Web)" prop="previewUrlThree">
              <el-input v-model="form.previewUrlThree"></el-input>
            </el-form-item>

            <el-form-item label="应用详情" prop="appDetail">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.appDetail"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-card>
        <el-form-item>
          <el-button type="primary" @click="onSubmitApp('form')"
            >保存</el-button
          >
          <el-button @click="resetForm('form')">重置</el-button>
          <el-button type="info" @click="showAppList = true">返回</el-button>
        </el-form-item>
      </el-form>
    </view>
  </div>
</template>
<script>
import { getAppList, addApp, getAppDetail, editApp } from "@/api/user";
import { getAppMarkHot, uploadBase64toImage } from "@/api/index";
import myUpload from "vue-image-crop-upload";
import { deepClone, base64toFile } from "@/utils/tool";
export default {
  components: {
    "my-upload": myUpload
  },
  data() {
    return {
      form: {
        name: "",
        code: "",
        appTypeId: [],
        description: "",
        loading: true,
        adapterSystem: "",
        logoUrl: "",
        showlogo: ""
      },
      rules: {
        adapterSystem: [
          { required: true, message: "请输入应用类型", trigger: "blur" },
          {
            min: 2,
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请输入应用名称", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入应用标签", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        description: [
          { required: true, message: "请输入应用描述", trigger: "blur" },
          {
            min: 2,
            trigger: "blur"
          }
        ],
        appTypeId: [
          { required: true, message: "请选择领域", trigger: "change" }
        ]
      },
      showAppList: true,
      appTypeList: [],
      appList: [],
      appPager: {
        pageSize: 10,
        curPageNumber: 1,
        total: 0
      },
      showLogo: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    toggleShowl() {
      this.showLogo = !this.showLogo;
    },
    //logoUrl剪切成功后的回调函数
    cropSuccesss(imgDataUrl) {
      var formData = new FormData();
      formData.append("file", base64toFile(imgDataUrl));
      uploadBase64toImage(formData).then(response => {
        this.form.logoUrl = response.result.filePath;
        this.form.showlogo = response.result.fileHttpPath;
      });
    },

    async handleEdit(row) {
      var { result } = await getAppDetail({ id: row.id });
      this.form = { ...result };
      this.form.showlogo = this.form.logoUrl;
      this.$forceUpdate();
      this.showAppList = false;
    },
    async init() {
      await this.getAppList();
      await this.getappTypeListList();
      this.loading = false;
    },
    async getappTypeListList() {
      let { result } = await getAppMarkHot();
      this.appTypeList = result;
    },
    onSubmitApp(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.loading = true;
          var data = deepClone(this[formName]);
          data.appTypeId = data.appTypeId.join(",");
          if (data.id) {
            let { message } = await editApp(data);
            this.$message({
              message: message,
              type: "success"
            });
            this.showAppList = true;
            this.getAppList();
            this.loading = false;
            this[formName] = {};
          } else {
            let { message } = await addApp(data);
            this.$message({
              message: message,
              type: "success"
            });
            this.showAppList = true;
            this.getAppList();
            this.loading = false;
            this[formName] = {};
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleAppCurrentChange(val) {
      this.appPager.curPageNumber = val;
      this.getAppList();
    },
    async getAppList() {
      await getAppList(this.appPager)
        .then(response => {
          this.appList = response.result.data;
          this.appPager.total = response.result.count;
          this.appPager.pageSize = response.result.pager.pageSize++;
          this.appPager.curPageNumber = response.result.pager.curPageNumber;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
